import { Spinner, type SpinnerProps } from 'react-bootstrap'
import { joinClasses } from '@/utils/styling';

interface LoaderProps {
    variant?: SpinnerProps['variant'];
    containerClass?: string;
}

export default function Loader({
    variant = "secondary",
    containerClass
}: LoaderProps) {
    return (
        <span className={joinClasses("d-block text-center", containerClass)}>
            <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
                variant={variant}
            />
            <span className="visually-hidden">Loading...</span>
        </span>
    )
}